export const Loader = ({ size = 'large' }) => {
  return <div className='loader'>Loading</div>;
};
